<template>
    <section class="activity-materials pt-4">
        <div class="container">
            <div class="row">
                <div
                    v-if="activity.extensiveProgram"
                    class="col-6 col-md-3 mb-5"
                >
                    <a
                        :href="activity.extensiveProgram"
                        download="activity.extensiveProgram"
                        @click.prevent="downloadItem(activity.extensiveProgram)"
                    >
                        <div class="activity-materials__content">
                            <i
                                class="fa fa-pencil-ruler"
                                aria-hidden="true"
                            ></i>
                            <span>Opdrachten</span>
                        </div>
                    </a>
                </div>
                <div v-if="activity.movie" class="col-6 col-md-3 mb-5">
                    <a :href="activity.movie" target="_blank">
                        <div class="activity-materials__content">
                            <i class="fa fa-play" aria-hidden="true"></i>
                            <span>Video</span>
                        </div>
                    </a>
                </div>
                <div
                    v-if="activity.preparationLesson"
                    class="col-6 col-md-3 mb-5"
                >
                    <a
                        :href="activity.preparationLesson"
                        download="activity.preparationLesson"
                        @click.prevent="
                            downloadItem(activity.preparationLesson)
                        "
                    >
                        <div class="activity-materials__content">
                            <i class="fa fa-file" aria-hidden="true"></i>
                            <span>Lesbrief</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        downloadItem(url) {
            axios
                .get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = url.replace('/Media/W3S.uBookings/', '');
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch();
        }
    }
};
</script>

<style lang="scss">
.activity-materials a {
    text-align: center;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.05);
    background-color: rgba(116, 100, 83, 0.13);
    border-radius: 34px 7px 7px 7px;
    position: relative;
    display: block;
    color: $purple;
    &:hover {
        text-decoration: none;
        .activity-materials__content {
            top: -10px;
        }

        .activity-materials__content i,
        .activity-materials__content span {
            color: $purple;
        }
    }
}

.activity-materials__content {
    top: 0;
    position: relative;
    padding: 44px 0px 6px 0px;
    transition: top 0.25s ease-in-out;

    @include media-breakpoint-up(md) {
        padding: 44px 0 18px 0;
    }
}

.activity-materials__content i {
    font-size: 64px;
    position: absolute;
    top: -32px;
    left: 50%;
    transform: translateX(-50%);
}

.activity-materials__content span {
    position: relative;
    font-family: $headings-font-family;
    font-size: 0.875rem;

    @include media-breakpoint-up(md) {
        font-size: 1rem;
    }
}
</style>
